export default __webpack_public_path__ + "static/media/link-dedicado.159b18ba.jpg";